import ACTION_ITEMS from './actionItems';

const initialState = {
  open: false,
  assessments: {},
};

export const anonResultsReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case ACTION_ITEMS.ANON_RESULTS.OPEN.SET: {
      newState = {
        ...state,
        open: action.payload,
      };
      break;
    }

    case ACTION_ITEMS.ANON_RESULTS.ASSESSMENTS.SET: {
      newState = {
        ...state,
        open: true,
        assessments: action.payload,
      };
      break;
    }

    case ACTION_ITEMS.ANON_RESULTS.ASSESSMENTS.RESET: {
      newState = {
        ...state,
        assessments: {},
      };
      break;
    }

    default:
      newState = state;
      break;
  }

  return newState;
};
